"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.restify = void 0;
const axios_1 = __importDefault(require("axios"));
const defaultInterceptors = {
    request: [],
    response: [],
};
function restify(baseURL, interceptors = defaultInterceptors) {
    const base = axios_1.default.create({
        baseURL,
    });
    interceptors.request.forEach((interceptor) => {
        base.interceptors.request.use(interceptor);
    });
    interceptors.response.forEach((interceptor) => {
        base.interceptors.response.use(interceptor);
    });
    /**
     * Returns an axios interface that extends upon the current active network request object
     * Example: api.users.one(userId).get('settings')
     */
    base.one = function one(...subPaths) {
        return restify(`${baseURL}/${subPaths.join('/')}`, interceptors);
    };
    return base;
}
exports.restify = restify;
